import styled from 'styled-components';

export const BackgroundATADashboard = styled.div`
    position: relative;
    width: 98%;
    max-width: 90%;
    margin: 30vh auto 60px;
    padding: 80px 20px 60px;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
    
    .title {
        height: 70px;
        border-right: 3px solid #f0f;
    }
    
    h2 {
        font-size: 40px;
        font-weight: normal;
    }
    
    .partner-info {
        padding: 1.25rem;        
        margin-bottom: 1.25rem;
        border: 1px solid #eee;
        border-left-width: .25rem;
        border-left-color: #5bc0de;
        border-radius: .25rem
    }
    
    #folio-partner-save {
        font-style: italic;
        color: #20c997;
    }
`;